export const dashboard = {
  title: 'Panel główny',
  statisticsTitle: 'Statystyki',
  navigationTitle: 'Szybka nawigacja',
  navigationDescription: 'Przejdź bezpośrednio do wybranej sekcji systemu',
  noSections: 'Brak dostępnych sekcji',
  tilesError: 'Nie udało się załadować kafelków nawigacyjnych',
  sectionsError: 'Nie udało się załadować danych statystycznych',
  sections: {
    dashboardDesc: 'Widok główny z nawigacją i najważniejszymi danymi',
    statisticsDesc: 'Wykresy i statystyki aktywności z ostatnich 30 dni',
    profileDesc: 'Zarządzaj swoim profilem użytkownika',
  },
  mostPopularProducts: 'Najpopularniejsze produkty ostatnich 30 dni',
  mostPopularBrands: 'Najpopularniejsze marki ostatnich 30 dni',
  mostPopularModels: 'Najpopularniejsze modele ostatnich 30 dni',
  mostPopularColors: 'Najpopularniejsze kolory ostatnich 30 dni',
} as const
